










import { Vue, Component, Prop } from "vue-property-decorator";
@Component({})
export default class ScaleCoordinateUI extends Vue {
  @Prop({
    default: () => { return false; }
  }) smallMobile: boolean;
  data() {
    return {
      MobileMenu: false
    }
  }
}
